import React from "react"

interface UseAdjustScrollOnPrependOptions {
  adjustScrollTopBy: (delta: number) => void
  isFetchingPreviousPage: boolean
  rowCount: number
  rowHeight: number
}

/**
 * After a previous page finishes loading, shifts virtual scroll so prepended
 * rows do not jump the viewport.
 */
export const useAdjustScrollOnPrepend = ({
  adjustScrollTopBy,
  isFetchingPreviousPage,
  rowCount,
  rowHeight,
}: UseAdjustScrollOnPrependOptions): void => {
  const previousRowCountRef = React.useRef(rowCount)
  const wasFetchingPreviousPageRef = React.useRef(false)

  React.useEffect(() => {
    const wasFetchingPreviousPage = wasFetchingPreviousPageRef.current
    const prependedRowCount = rowCount - previousRowCountRef.current

    if (
      wasFetchingPreviousPage &&
      !isFetchingPreviousPage &&
      prependedRowCount > 0
    ) {
      adjustScrollTopBy(prependedRowCount * rowHeight)
    }

    wasFetchingPreviousPageRef.current = isFetchingPreviousPage
    previousRowCountRef.current = rowCount
  }, [adjustScrollTopBy, isFetchingPreviousPage, rowCount, rowHeight])
}
